var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducationalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_device-message",
    "data-name": "vuesax/linear/device-message",
    transform: "translate(-300 -250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "device-message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18,8.2V9.9c0,3.15-1.8,4.5-4.5,4.5h-9C1.8,14.4,0,13.05,0,9.9V4.5C0,1.35,1.8,0,4.5,0H7.2A3.854,3.854,0,0,0,7,1.25v3.9a3.263,3.263,0,0,0,.89,2.36,3.263,3.263,0,0,0,2.36.89V9.79a.655.655,0,0,0,1.01.54L14.15,8.4h2.6A3.854,3.854,0,0,0,18,8.2Z",
    transform: "translate(302 254)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M13,3.25v3.9a3.048,3.048,0,0,1-2,3.05,3.854,3.854,0,0,1-1.25.2H7.15L4.26,12.33a.655.655,0,0,1-1.01-.54V10.4A3.263,3.263,0,0,1,.89,9.51,3.263,3.263,0,0,1,0,7.15V3.25A3.854,3.854,0,0,1,.2,2,3.048,3.048,0,0,1,3.25,0h6.5A3.071,3.071,0,0,1,13,3.25Z",
    transform: "translate(309 252)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H7.2",
    transform: "translate(307.4 272)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0V3.6",
    transform: "translate(311 268.4)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(300 250)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M.5.5H.5",
    transform: "translate(318 256.75)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M.5.5H.5",
    transform: "translate(315.2 256.75)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M.5.5H.5",
    transform: "translate(312.4 256.75)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationalIcon);
export default __webpack_public_path__ + "static/media/educationalIcon.33fa3f309f394b9a209610c4cb7bd054.svg";
export { ForwardRef as ReactComponent };